import { motion } from "framer-motion";
import { Eyebrow, PrimaryButton } from "@/components/ui-bits";

const AboutHero = () => {
  return (
    <section data-testid="about-hero" aria-labelledby="about-hero-heading" className="relative overflow-hidden bg-white">
      <div className="grid lg:min-h-[560px] lg:grid-cols-12">
        <div className="container-30 flex items-center py-16 sm:py-20 lg:col-span-6 lg:py-24 lg:pr-0">
          <div className="max-w-xl">
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}>
              <Eyebrow>About 30 NORTH</Eyebrow>
            </motion.div>
            <motion.h1
              id="about-hero-heading"
              data-testid="about-hero-headline"
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="mt-6 text-4xl font-black leading-[1.02] tracking-tight text-[#191c1e] sm:text-5xl lg:text-6xl"
            >
              BUILT ON EXPERIENCE. FOCUSED ON EXECUTION.
            </motion.h1>
            <motion.p
              data-testid="about-hero-subcopy"
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
              className="mt-6 text-base leading-relaxed text-[#5f666d] sm:text-lg"
            >
              30 NORTH brings 6+ years of hands-on logistics and supply chain experience to the transportation
              industry. We understand what businesses need from their transportation partner: clear communication,
              responsive coordination, and solutions that work.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
              className="mt-10"
            >
              <PrimaryButton to="/request-a-quote" testid="about-hero-cta" className="w-full sm:w-auto">
                REQUEST A QUOTE
              </PrimaryButton>
            </motion.div>
          </div>
        </div>
        <div className="relative h-72 sm:h-96 lg:col-span-6 lg:h-auto">
          <motion.img
            src="/assets/about-hero-2.webp"
            alt="The Mississauga skyline with the Absolute World towers, home of 30 NORTH"
            data-testid="about-hero-image"
            initial={{ opacity: 0, scale: 1.04 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-y-0 left-0 hidden w-24 bg-gradient-to-r from-white to-transparent lg:block" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
